import { AllDeviceTemplateProps } from "../../constants/types";
import AllDeviceOverallCard from "../organisms/all/AllDeviceOverallCard";
import AllDeviceProjectsConnectionCard from "../organisms/all/AllDeviceProjectsConnectionCard";
import PublicTemplate from "../publics/PublicTemplate";

const AllDeviceTemplate = (props: AllDeviceTemplateProps) => {
  return (
    <PublicTemplate justify="space-between">
      <>
        <AllDeviceProjectsConnectionCard data={props.data} />
        <AllDeviceOverallCard
          data={props.data}
          categories={props.categories}
          option={props.option}
          render={props.render}
          page={props.page}
        />
      </>
    </PublicTemplate>
  );
};

export default AllDeviceTemplate;
